module.exports = __webpack_public_path__ + "videos/metrics.999d015.mp4";